import { EmptyPageSimulations } from 'components/shared/empty-screen-page'
import IncomingSimulationCard from 'components/shared/incoming-simulation-card'
import useTranslation from 'next-translate/useTranslation'

const IncomingPage = (props: SimulationsNotebook) => {
    const { t } = useTranslation('simulation')

    return props.simulations?.length === 0 ? (
        <EmptyPageSimulations
            title={t('emptyState.incoming.title')}
            description={t('emptyState.incoming.description')}
        />
    ) : (
        <div className="w-full  grid grid-cols-1  md:grid-cols-2 lg:grid-cols-3 gap-3">
            {props.simulations?.map((v) => (
                <div key={v._id} className="w-full">
                    <IncomingSimulationCard simulation={v} isLive={v.type === 'LIVE'} />
                </div>
            ))}
        </div>
    )
}

export default IncomingPage
